const routes = {
    home: '/',
    aboutUs: '/about-us',
    contact: '/contact',
    login: '/login',
    register: '/register',
    changePasword: '/change-password',
    write: '/write',
    editPost: '/write/:id',
    profile: '/me',
    saved: '/me/saved',
    detailPost: '/post/:id',
    search: '/search',
};
export default routes;
